import {
  SportCompetitionScheduleQueryResponse,
  SportCompetitorScheduleAPIResponse,
  SportCompetitorScheduleItem,
} from '@hooks/useSportEntitySchedule/types'

const isMostRecentItem = (
  items: SportCompetitorScheduleAPIResponse['items'],
  matchId: string,
): boolean => {
  const mostRecentItem = items.find((item) => {
    return (
      item.isLive === true ||
      (item.startTime && new Date(item.startTime) >= new Date())
    )
  })

  return mostRecentItem?.matchId === matchId
}

const getMostRecentItems = (
  items: SportCompetitorScheduleAPIResponse['items'],
): SportCompetitorScheduleItem[] => {
  const today = new Date().toISOString().split('T')[0]

  const mostRecentGameIndex = items.findIndex((item) => {
    return (
      item.isLive === true ||
      (item.startTime && new Date(item.startTime) >= new Date(today))
    )
  })

  if (mostRecentGameIndex === -1) {
    return items.slice(0, 5)
  }

  const start = Math.max(0, mostRecentGameIndex - 2)
  const end = Math.min(items.length, mostRecentGameIndex + 3)

  return items.slice(start, end)
}

const getCurrentRoundId = ({
  rounds,
  items,
}: {
  rounds: SportCompetitionScheduleQueryResponse['rounds']
  items: SportCompetitionScheduleQueryResponse['items']
}) => {
  const today = new Date().toISOString().split('T')[0]

  for (const [roundId, roundItems] of Object.entries(items)) {
    const hasLiveOrUpcomingItem = roundItems.some(
      (item) =>
        item.isLive === true ||
        (item.startTime && new Date(item.startTime) >= new Date(today)),
    )

    if (hasLiveOrUpcomingItem) {
      return roundId
    }
  }

  return rounds[rounds.length - 1]?.id
}

export { getMostRecentItems, isMostRecentItem, getCurrentRoundId }
